import { SourceProps, LayerProps } from 'react-map-gl'

export const clusterCountLayerStyle: LayerProps = {
  id: 'cluster-count',
  type: 'symbol',
  source: 'places',
  filter: ['has', 'point_count'],
  layout: {
    'text-field': [
      'coalesce',
      ['get', 'clusterName'],
      ['get', 'point_count_abbreviated']
    ], //'{point_count_abbreviated}',
    'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
    'text-size': 14
  },
  paint: {
    'text-color': '#000',
    'text-halo-color': 'rgba(255,255,255,0.9)',
    'text-halo-width': 1.5,
    'text-halo-blur': 0
  }
}
